import React from 'react';
import { useReveal } from '../lib/useReveal';
const BONUSES = [{
  title: 'REIKI EN 7 DÍAS',
  desc: 'Tu guía de inicio rápido. Primera semana completamente estructurada. Sin excusas para no empezar hoy.',
  value: '$4.990'
}, {
  title: 'MAPA DE CHAKRAS APLICADO',
  desc: 'El mapa visual completo del sistema energético con protocolos específicos para cada centro. Tu referencia permanente de diagnóstico.',
  value: '$4.990'
}, {
  title: 'MANUAL ANTI-DUDAS',
  desc: 'Las 50 preguntas más frecuentes respondidas con claridad. Nunca más te quedás paralizada/o por una duda en medio de una sesión.',
  value: '$3.990'
}, {
  title: 'REIKI PARA ANSIEDAD Y ESTRÉS',
  desc: '12 protocolos de 10 minutos para situaciones específicas. Insomnio, pánico, estrés laboral, dolor emocional. Con tarjetas imprimibles.',
  value: '$4.990'
}, {
  title: 'REIKI DE BOLSILLO',
  desc: 'Checklists completos de sesión para auto y para otro. Nunca más el "¿qué viene ahora?" en medio de una sesión.',
  value: '$3.990'
}, {
  title: 'DIARIO DE PRÁCTICA Y PROGRESO 30 DÍAS',
  desc: 'Tu herramienta de seguimiento con métricas reales de energía, sueño, estrés y claridad. Convertí la práctica en hábito con evidencia concreta de tu transformación.',
  value: '$4.990'
}];
export function BonusesSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#0a0a0a] py-12 md:py-16 px-5 sm:px-6 border-t border-white/5 relative overflow-hidden" data-id="element-44">
      <div className="container mx-auto max-w-6xl relative z-10" data-id="element-45">
        <div ref={ref1} className={`reveal text-center mb-8 ${vis1 ? 'is-visible' : ''}`} data-id="element-46">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-4" data-id="element-47">
            Y además recibís 6 Bonos Exclusivos
          </h2>
          <p className="text-xl md:text-2xl text-[#eab308] font-serif italic" data-id="element-48">
            Valorados en $27.940 — incluidos sin costo extra
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-49">
          {BONUSES.map((bonus, idx) => <div key={idx} className="bg-[#111111] border border-white/5 rounded-xl p-4 sm:p-5 flex flex-col h-full" data-id="element-50">
              <div className="inline-flex self-start bg-gradient-to-r from-[#eab308] to-[#d4a017] text-[#0f0f1a] text-[10px] font-bold px-3 py-1 rounded-full mb-3 whitespace-nowrap" data-id="element-51">
                🎁 BONO #{idx + 1}
              </div>

              <h3 className="text-sm sm:text-base font-bold text-white mb-2 uppercase tracking-wide" data-id="element-52">
                {bonus.title}
              </h3>

              <p className="text-gray-400 text-xs sm:text-sm leading-relaxed mb-4 flex-grow" data-id="element-53">
                {bonus.desc}
              </p>

              <div className="flex items-center justify-between border-t border-white/10 pt-3 mt-auto" data-id="element-54">
                <span className="text-gray-500 text-xs line-through decoration-red-500/50" data-id="element-55">
                  Valor: {bonus.value}
                </span>
                <span className="text-[#eab308] font-bold text-xs uppercase tracking-wider" data-id="element-56">
                  HOY: GRATIS
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}